import {T} from '../../../utils/I18n/I18n';
import { gql } from '@apollo/client';
import PropTypes from 'prop-types';
import React, {memo, useContext} from 'react';
import {useQuery} from '@apollo/client';
import {Link} from 'react-router-dom';
import {useUserContext} from '../../../context/UserContext';
import {GET_CARD} from '../../PersonalArea/PersonalAreaClub/queriesClub';
import './ProductSidebarClub.scss';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';
const countryCode = readConfig(productionConfiguration, 'countryCode');

// TODO: Figure out rounding error causing a difference of 1 point
function getBonusesForBanking(price, rate) {
    return Math.floor(price / rate) || 0;
}

export const FETCH_CONFIG = gql`
  query fetchLoyaltyConversion {
    backendConfig {
      shop {
        loyaltyConversion
      }
    }
  }
`;

const ProductSidebarClub = ({product}) => {
    let price;
    if (product.__typename === 'GroupedProduct') {
        price = product.items.reduce((sum, item) => {
            if (item.product && item.product.prices) {
                return sum + item.product.prices.reduce((itemSum, price) => {
                    return itemSum + (parseFloat(price.amount) || 0);
                }, 0);
            }
            return sum;
        }, 0);
    } else {
        const prices = (product?.prices || []).filter((price) => {
            return ['simple_clearance', 'simple_regular', 'simple_loyalty'].includes(price.price_type)
        }).map((price) => {
            return parseFloat(price.amount);
        });

        price = prices.length > 0 ? Math.min(...prices) : 0;
    }
    const {user} = useUserContext();
    const {data: card} = useQuery(GET_CARD, {
        fetchPolicy: 'no-cache',
        skip: !user,
    });

    const getBonusesForBanking = (price, rate) => {
        return Math.floor(price / rate) || 0;
    }

    const {data, loading} = useQuery(FETCH_CONFIG);

    const {loyaltyConversion: rate} = data && data.backendConfig && data.backendConfig.shop || {};
    const bankingBonus = Math.ceil(getBonusesForBanking(price, rate));


    if (loading) {
        return <></>;
    }
    return (
        <div className="sidebar-club">
            <div className="sidebar-club__header">
                <img src="https://s3.emmezeta.hr/falcon/emm-club-logo.webp" alt=""/>
                {countryCode === 'hr-HR' && <img src="https://s3.emmezeta.hr/falcon/emm-club-card.webp" alt="" className="sidebar-club__card"/>}
                {countryCode === 'sr-RS' && <img src="https://s3.emmezeta.hr/falcon/klub_kartica_rs.webp" alt="" className="sidebar-club__card"/>}
            </div>
            <div className="sidebar-club__bonuses">
                <div className="sidebar-club__bonus-text">
                    <T id="product.clubBonusHeader01"/>
                    <br/>
                    <T id="product.clubBonusHeader02"/>
                </div>
                <div className="sidebar-club__bonus-values">
                    {bankingBonus * 2} - <T id="product.bonusForEbanking"/>
                </div>
                <div className="sidebar-club__bonus-values">
                    {bankingBonus} - <T id="product.bonusForCard"/>
                </div>
            </div>
            <div className="sidebar-club__info">
                {!user && (
                    <div className="sidebar-club__profile">
                        <T id="product.needRegister"/>
                        <br/>
                        <Link to="/customer/account/">
                            <T id="product.toProfile"/>
                        </Link>
                    </div>
                )}

                {card && card.historyCustomerLoyaltyCard && card.historyCustomerLoyaltyCard.loyalty ? (
                    <></>
                ) : (
                    <div className="sidebar-club__no-card">
                        <T id="product.noCard"/>
                        {user && (
                            <Link to="/customer/account/loyalty" className="sidebar-club__link">
                                <T id="product.askHere"/>
                            </Link>
                        )}
                        {!user && (
                            <Link to="/emmezeta-klub" className="sidebar-club__link">
                                <T id="product.askHere"/>
                            </Link>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

ProductSidebarClub.propTypes = {
    product: PropTypes.object,
};

export default memo(ProductSidebarClub);
